import { render, staticRenderFns } from "./manage_product.vue?vue&type=template&id=2b164fc9&scoped=true"
import script from "./manage_product.vue?vue&type=script&lang=js"
export * from "./manage_product.vue?vue&type=script&lang=js"
import style0 from "./manage_product.vue?vue&type=style&index=0&id=2b164fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b164fc9",
  null
  
)

export default component.exports